<template>
  <div class="container-fluid">
    <div>
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col col-xs-2">
              <h5 class="panel-title">Bem Vindo(a) {{this.currentUser.usuario.nome}}</h5>
            </div>
          </div>
        </div>
        <div id="topo" class="card-body" >
          <h5 class="panel-title">
            <span class="title">Selecione o Contribuinte para acesso.</span>
          </h5>
          <div class="row">
            <div class="col-md-2 col-lg-2 mb-2">
              <span class="p-fluid">
                <Dropdown
                  id="tipoConsulta"
                  name="tipoConsulta"
                  v-model="selectedTipoConsulta"
                  :options="tiposConsulta"
                  optionLabel="name"
                  placeholder="Tipo Consulta:"
                />
              </span>
            </div>
            <div class="col-md-2 col-lg-2 mb-2" v-if="this.currentUser.usuario.idBolAdmin">
              <span class="p-fluid">
                <Dropdown
                  id="tipoSelecao"
                  name="tipoSelecao"
                  v-model="selectedTipoSelecao"
                  :options="tiposSelecao"
                  optionLabel="name"
                  placeholder="Tipo Seleção:"
                />
              </span>
            </div>
            <div class="col-md-4 mb-2">
              <span class="p-fluid">
                <InputText class="inputPesquisa" v-model="filtro" placeholder="Filtro" @keyup.enter="pesquisar"/>
              </span>
            </div>
            <div class="mb-2">
              <Button
                @click="pesquisar()"
                label="Pesquisar"
                type="button"
                class="p-button-primary mr-2"
                icon="pi pi-search"
                :disabled="loading"
              />
            </div>
          </div>
          <div class="row">
            <DataTable
              :value="usuarioList"
              :paginator="true"
              :rows="10"
              :scrollable="false"
              :autoLayout="true"
              class="p-datatable-responsive"
            >
              <template #header>
                <div style="line-height:1.87em" class="p-clearfix">Lista de Contribuintes.</div>
              </template>

              <Column header="Selecionar" headerStyle="width: 8em" bodyStyle="text-align: center">
                <template #body="slotProps">
                  <Button
                    title="Selecionar Contribuinte"
                    type="button"
                    icon="pi pi-check"
                    @click="selecionarContribuinte(slotProps.data.idUsuarioSelecionado, slotProps.data.idContribuinte)"
                  ></Button>
                </template>
              </Column>
              <Column
                headerStyle="width: 8em"
                header="Atualizar Senha"
                bodyStyle="text-align: center"
                v-if="this.currentUser.usuario.idBolAdmin"
              >
                <template #body="slotProps" >
                  <Button
                    title="Atualizar Senha"
                    type="button"
                    icon="pi pi-key"
                    v-if="slotProps.data.credenciado === 'S'"
                    @click="atualizarSenha(slotProps.data.idUsuarioSelecionado, slotProps.data.idPessoa)"
                  ></Button>
                </template>
              </Column>
              <Column
                headerStyle="width: 8em"
                header="Desvincular Empresa"
                bodyStyle="text-align: center"
                v-if="!this.currentUser.usuario.idBolAdmin"
              >
                <template #body="slotProps" >
                  <Button
                    title="Desvincular Empresa"
                    type="button"
                    icon="pi pi-user-minus"
                    v-if="slotProps.data.credenciado === 'S'"
                    @click="openDesvincEmp(slotProps.data.idUsuario, slotProps.data.idContribuinte, slotProps.data.idUsuarioSelecionado)"
                  ></Button>
                </template>
              </Column>
              <Column header="Documento" headerStyle="width: 12em">
                <template #body="slotProps">
                  <span class="p-column-title">Documento</span>
                  {{slotProps.data.documento}}
                </template>
              </Column>
              <Column header="Nome">
                <template #body="slotProps">
                  <span class="p-column-title">Nome</span>
                  {{slotProps.data.nome}}
                </template>
              </Column>
              <Column header="Inscrição Municipal" headerStyle="width: 12em">
                <template #body="slotProps">
                  <span class="p-column-title">Inscrição Municipal</span>
                  {{slotProps.data.inscricaoMunicipal}}
                </template>
              </Column>
              <Column header="Tipo de Cadastro" headerStyle="width: 12em">
                <template #body="slotProps">
                  <span class="p-column-title">Tipo de Cadastro</span>
                  {{slotProps.data.tipoCadastro}}
                </template>
              </Column>
              <Column header="Situação" headerStyle="width: 8em">
                <template #body="slotProps">
                  <span class="p-column-title">Situação</span>
                  {{slotProps.data.situacao}}
                </template>
              </Column>
            </DataTable>
          </div>
          <div class="row" v-if="isUsuarioContador">
            <div class="mb-2 mt-2">
              <Button
                @click="openSelecaoEmpresa()"
                label="Vincular Empresa"
                type="button"
                class="p-button-primary mr-2"
                icon="pi pi-user-plus"
                :disabled="loading"
              />
            </div>
          </div>
        </div>
      </div>

      <Dialog class="tomador-modal" header="Seleção de Contribuinte" :visible.sync="showSelecaoEmpresaContador" :modal="true" :closable="false">
        <h1 class="titulo-header">
          Seleção de Contribuinte
          <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
            @click="showSelecaoEmpresaContador = false" />
        </h1><br />
        <div class="scrolable-dialog selecao-contribuinte">
          <div class="row">
            <div class="col-md-4 mb-2">
              <span class="p-fluid">
                <InputText v-model="filtroSelecaoEmpresaContador" placeholder="CPF/CNPJ" @keyup.enter="pesquisar"/>
              </span>
            </div>
            <div class="mb-2">
              <Button
                @click="pesquisarPeloContador()"
                label="Pesquisar"
                type="button"
                class="p-button-primary mr-2"
                icon="pi pi-search"
                :disabled="loading"
              />
            </div>
          </div>
          <div class="row">
            <DataTable :value="usuarioListContador" :paginator="true" :rows="5" style="min-width: 100%">
              <Column headerStyle="width: 20%" field="documento" header="Documento"></Column>
              <Column headerStyle="width: 40%" field="nome" header="Nome"></Column>
              <Column headerStyle="width: 15%" field="inscricaoMunicipal" header="Inscrição Municipal"></Column>
              <Column headerStyle="width: 15%" field="situacao" header="Situação"></Column>
              <Column headerStyle="width: 58px" bodyStyle="text-align: center">
                <template #body="objeto">
                  <Button type="button" icon="pi pi-check" title="Selecionar Contribuinte"
                    @click="vincularEmpresa(objeto.data.idUsuario, objeto.data.idContribuinte)"></Button>
                </template>
              </Column>
            </DataTable>
          </div>
        </div>

        <hr />

        <div class="container">
          <div class="row">
            <div>
              <Button @click="closeSelecaoEmpresa()" type="button" label="Fechar"
                class="p-button-primary mr-2 p-button-danger" icon="pi pi-times" />
            </div>
          </div>
        </div>
      </Dialog>

      <Dialog
        class="test-box"
        header="Deseja Realmente Efetuar Essa Ação?"
        :visible.sync="showDesvincEmp"
        :contentStyle="{ overflow: 'visible' }"
        :modal="true"
        :closable="false"
      >
      <h1 class="titulo-header">
        Deseja Realmente Efetuar Essa Ação?
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="showDesvincEmp = false" />
      </h1><hr />
        <template>
          <Button label="Sim" title="Sim" @click=desvincularEmpresa() class="p-button-primary  mr-2 p-button-success"
            icon="pi pi-check" :disabled="loading">
          </Button>
          <Button label="Cancelar" title="Cancelar" @click=closeDesvincEmp() class="p-button-primary  mr-2 p-button-danger"
            icon="pi pi-timmes" :disabled="loading">
          </Button>
        </template>
      </Dialog>
      <Dialog
        class="test-box"
        header="É necessário fazer o Login novamente para a atualização das informações!"
        :visible.sync="showPushLogin"
        :contentStyle="{ overflow: 'visible' }"
        :modal="true"
        :closable="false"
      >
      <h1 class="titulo-header">
        É necessário fazer o Login novamente para a atualização das informações!
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="showPushLogin = false" />
      </h1><hr />
        <template>
          <Button label="Confirmar" title="Confirmar" @click=refreshSistema() class="p-button-primary  mr-2 p-button-success"
            icon="pi pi-check" :disabled="loading">
          </Button>
        </template>
      </Dialog>
    </div>
  </div>
</template>
<script>
import UsuarioAcessoService from "../services/nfse/usuario.acesso.service";
import LoginService from "../services/acesso/login.service";
import Util from "../Utils/util";

export default {
  name: "selecaoEmpresa",
  data() {
    return {
      loading: false,
      filters: {},
      filtro: null,
      tiposConsulta: [],
      tiposSelecao: [],
      selectedTipoConsulta: null,
      selectedTipoSelecao: null,
      usuarioList: [],
      contadorMsg: null,
      showDesvincEmp: false,
      usuarioListContador: [],
      showSelecaoEmpresaContador: false,
      filtroSelecaoEmpresaContador: null,
      showPushLogin: false,
      idUsuario: null,
      idContribuinte: null,
      idUserSelec: null
    };
  },
  created() {
    this.filtro = "";
    this.selectedTipoConsulta = { name: "CPF/CNPJ", key: "D" };
    this.selectedTipoSelecao = { name: "Credenciados", key: "C" };
    this.tiposConsulta = [
      { name: "CPF/CNPJ", key: "D" },
      { name: "Nome Contribuinte", key: "N" },
      { name: "Inscrição Municipal", key: "I" }
    ];
    this.tiposSelecao = [
      { name: "Credenciados", key: "C" },
      { name: "TODOS", key: "T" }
    ];
    this.currentUser = LoginService.currentUserValue;
    this.pesquisar();
  },
  watch: {
    currentUser(newValue, oldValue) {
      if (newValue !== oldValue) {
        // Lógica para quando currentUser mudar
        window.localtion.reload();
        UsuarioAcessoService.refreshAccess(this.currentUser).then(response => {
          this.currentUser = LoginService.updateStorage(response.data);
        })
      }
    }
  },
  methods: {
    processando(show) {
      if (show) {
        this.loading = true;
        this.$root.$emit("loading:show");
      } else {
        this.loading = false;
        this.$root.$emit("loading:hide");
      }
    },
    pesquisar() {
      this.processando(true);
      this.search = true;
      if (this.filtro && this.selectedTipoConsulta) {
        console.log("Consulta com filtro");
        UsuarioAcessoService.findAllByUsuarioFiltro(
          this.currentUser.usuario.idCliente,
          this.currentUser.usuario.idUsuario,
          this.filtro,
          this.selectedTipoConsulta.key,
          this.selectedTipoSelecao.key,
          'N' //Pesquisa pelo contador
        ).then(ua => {
          this.usuarioList = ua.data;
        }).then(() => {
          this.processando(false);
          this.search = false;
        });
      } else {
        UsuarioAcessoService.findAllByUsuario(
          this.currentUser.usuario.idCliente,
          this.currentUser.usuario.idUsuario
        ).then(ua => {
          this.usuarioList = ua.data;
          if(this.usuarioList.length == 1 && !this.isUsuarioContador){
            this.openPushLogin();
          }
        }).then(() => {
          this.processando(false);
          this.search = false;
        });
        
      }
      
    },
    pesquisarPeloContador() {
      this.processando(true);
      this.search = true;
      if (this.validarDocumento()) {
        console.log("Consulta com filtro por contador");
        UsuarioAcessoService.findAllByUsuarioFiltro(
          this.currentUser.usuario.idCliente,
          this.currentUser.usuario.idUsuario,
          this.filtroSelecaoEmpresaContador,
          'D', //Cpf/cnpj
          'C', //Credenciados,
          'S' //pesquisa pelo contador
        ).then(ua => {
          this.usuarioListContador = ua.data;
          if(!this.usuarioListContador || this.usuarioListContador.length <= 0){
            this.$root.$emit("alert:error", "Não foram encontrados registros de contribuinte credenciado com este documento!");
          }
          this.processando(false);
          this.search = false;
        })
      }else{
        this.processando(false);
      }   
      
    },
    validarDocumento() {
      var validar = false;
      validar = Util.validarCPFCNPJ(this.filtroSelecaoEmpresaContador);

      if (!validar) {
        console.log(validar);
        this.$root.$emit("alert:error", "O CPF/CNPJ informado para pesquisa é inválido!");
      }
      return validar;
    },
    selecionarContribuinte(idUsuarioSelecionado, idContribuinte) {
      this.processando(true);
      UsuarioAcessoService.selecionarContribuinte(
        this.currentUser,
        idUsuarioSelecionado,
        idContribuinte
      ).then(
        response => {
          LoginService.updateStorage(response.data);
          localStorage.setItem('displayInformacao', null);
          const homePage = LoginService.currentUserValue.homePage;
          console.log('HOME PAGE');
          console.log(homePage);
          this.$router.push(homePage);
          this.$root.$emit('contribuinte:trocado');
        },
        error => {
          console.log(error);
        }).then(() => {
          this.processando(false);
        });
    },
    atualizarSenha(idUsuario, idPessoa) {
      let link = "/recuperarSenha?chave=" + idUsuario + ";" + idPessoa;
      LoginService.logOut();
      this.$router.push(link);
    },
    openDesvincEmp(idUsuario, idContribuinte, idUsuarioSelecionado){
      this.idUsuario = idUsuario;
      this.idContribuinte = idContribuinte;
      this.idUserSelec = idUsuarioSelecionado;
      this.showDesvincEmp = true;
    },
    closeDesvincEmp(){
      this.showDesvincEmp = false;
    },
    openSelecaoEmpresa(){
      this.showSelecaoEmpresaContador = true;
    },
    closeSelecaoEmpresa(){
      this.showSelecaoEmpresaContador = false;
    },
    desvincularEmpresa(){
      UsuarioAcessoService.removerUserEmpresa(this.idUsuario, this.idContribuinte).then(
        response =>{
          this.$toast.add({severity:'success', summary: 'Empresa Desvinculada com Sucesso', life: 4500});
          this.closeDesvincEmp();
          this.pesquisar();
          console.log(response);
        },
        error =>{
          console.log(error)
        });
    },
    vincularEmpresa(idUsuario, idContribuinte){
      this.processando(true);
      this.search = true;
      UsuarioAcessoService.adicionarUserEmpresa(idUsuario, idContribuinte, this.currentUser.usuario.idCliente).then(
        response =>{
          this.$root.$emit('alert:success', 'Empresa Vinculada com Sucesso');
          this.closeSelecaoEmpresa();
          this.pesquisar();
          console.log(response);
        },
        error =>{
          if (error.response.data.length) {
            this.$root.$emit('alert:warn', error.response.data[0]);
          }
        }).then(() => {
          this.processando(false);
          this.search = false;
        });
      },
    atualizaSessao(){
      console.log(this.usuarioList);
      console.log(this.usuarioList.length);
      console.log("entrou");
      this.idUserSelec = this.usuarioList[0].idUsuario;
      this.idContribuinte = this.usuarioList[0].idContribuinte;
    },
    openPushLogin(){
      this.showPushLogin = true;
    },
    closePushLogin(){
      this.showPushLogin = false;
    },
    refreshSistema(){
      this.$router.push('/login');
    },
  },
  computed: {
    isUsuarioContador(){
      return this.currentUser.usuario.idBolContador;
    }
  }
};
</script>

<style src="../assets/css/selecaoEmpresa.css"></style>